import PropTypes from "prop-types";
import React, { memo, Fragment, useState } from "react";
import {
  Card,
  Col,
  CardBody,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { MoreVertical, Edit, Trash } from "lucide-react";
import buildingIcon from "../../assets/images/icons/building.gif";

const ClassRoomCard = memo(({ classroom, onEdit, onDelete }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = () => setDropdownOpen((prevState) => !prevState);

  return (
    <Fragment>
      <Col xl="3" sm="6">
        <Card>
          <CardBody>
            <div className="d-flex justify-content-between align-items-start">
              <div className="d-flex justify-content-center mt-4">
                <img
                  src={buildingIcon}
                  className="img-fluid w-25"
                  alt="Building Icon"
                  loading="lazy"
                />
                <div>
                  <h5 className="text-muted ms-2">
                    Room: {classroom.room_number}
                  </h5>
                  <h6 className="text-muted ms-2">
                    Building: {classroom.building?.name ?? "N/A"}
                  </h6>
                  <h6 className="text-muted ms-2">
                    Capacity: {classroom.total_strength}
                  </h6>
                </div>
              </div>
              <Dropdown
                isOpen={dropdownOpen}
                toggle={toggleDropdown}
                direction="down"
              >
                <DropdownToggle
                  tag="span"
                  data-toggle="dropdown"
                  aria-expanded={dropdownOpen}
                  style={{ cursor: "pointer" }}
                >
                  <MoreVertical size={20} />
                </DropdownToggle>
                <DropdownMenu end>
                  <DropdownItem onClick={() => onEdit(classroom)}>
                    <Edit size={16} className="me-2" /> Edit
                  </DropdownItem>
                  <DropdownItem onClick={() => onDelete(classroom.id)}>
                    <Trash size={16} className="me-2 text-danger" /> Delete
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>
          </CardBody>
        </Card>
      </Col>
    </Fragment>
  );
});

ClassRoomCard.propTypes = {
  classroom: PropTypes.shape({
    room_number: PropTypes.string.isRequired,
    building: PropTypes.shape({
      name: PropTypes.string,
    }),
    total_strength: PropTypes.number.isRequired,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }).isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default ClassRoomCard;
